import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { CommonService } from './_services/common.service';
import { AuthService } from './_services/auth.service';
import { ThemeService } from './_services/theme.service';
import { BrandingService } from './_services/branding.service';

// declare gtag as a function to access the JS code in TS
declare let gtag: Function;
@Component({
  selector: 'tangram-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'tangram-angular';
  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private themeService: ThemeService,
    private brandingService: BrandingService,
  ) {
    // Apply cached CSS vars immediately — prevents flash of unstyled content
    // before the async API call in ngOnInit completes.
    this.themeService.applyFromLocalStorage();

    /** check device is mobile or desktop */
    if (this.commonService.checkDeviceIsMObileOrNot()) {
      gtag('event', 'device_type', {
        'event_category': 'fetch_device',
        'event_label': 'mobile'
      });
    } else {
      gtag('event', 'device_type', {
        'event_category': 'fetch_device',
        'event_label': 'web'
      });
      // this
      //   .googleAnalyticsService
      //   .eventEmitter('device_type','fetch_device','web');
    }
  }

  ngOnInit(): void {
    // If a session exists from a previous visit, immediately apply the user's
    // saved theme so the first paint is correct (no flash of unstyled content).
    if (this.authService.currentUserValue) {
      this.themeService.refreshFromApi().subscribe({
        error: () => this.themeService.applyDefaults(),
      });
    } else {
      // Public routes (login, register, home, reset-password, etc.) — there's
      // no per-user saved theme to fetch. Pin to light mode so the first paint
      // matches the marketing/auth design instead of the (premium-only) dark.
      this.themeService.applyMode('light');
    }

    // When a user logs in (or out) mid-session, refresh the theme so their
    // saved palette/mode is applied immediately — without waiting for a hard
    // reload. Skip the very first emission if it just mirrors the bootstrap
    // value we already handled above.
    let bootstrapped = !!this.authService.currentUserValue;
    this.authService.currentUser.subscribe((user) => {
      if (!bootstrapped) {
        bootstrapped = true;
        return;
      }
      if (user) {
        this.themeService.refreshFromApi().subscribe({
          error: () => this.themeService.applyDefaults(),
        });
      } else {
        this.themeService.applyMode('light');
      }
    });

    // Active branding (logo / banner) is needed on every route — including
    // public ones (login, register, home, reset-password, etc.) that bypass
    // LayoutComponent. Fetching here at app bootstrap covers all of them.
    this.brandingService.refreshActiveBranding().subscribe({ error: () => {} });

    // Re-assert the active theme on every route change. Some pages manipulate
    // <html>/<body> attributes or inject component-scoped styles during their
    // ngOnInit that can briefly win over the theme gate — reapplying the
    // cached vars+mode synchronously on NavigationEnd guarantees there's no
    // flash of the default palette between routes.
    this.router.events
      .pipe(filter(e => e instanceof NavigationStart || e instanceof NavigationEnd))
      .subscribe(() => this.themeService.applyFromLocalStorage());
  }
}
